import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Save } from '@material-ui/icons';
import { Button, CircularProgress, Divider } from '@material-ui/core';

import { showAlert } from '../../store/ducks/alert';
import { getEmailTemplateStyleById, updateEmailTemplateStyle, deleteEmailTemplateStyle } from '../../services/channel';
import EditableInput from '../../components/EditableInput/EditableInput';
import EditableSelect from '../../components/EditableSelect/EditableSelect';
import UneditableInput from '../../components/UneditableInput/UneditableInput';

const EmailTemplateStylesInformation = props => {
  const dispatch = useDispatch();

  const [emailTemplateStyle, setEmailTemplateStyle] = useState({});
  const [styleSheet, setStyleSheet] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getCurrentEmailTemplateStyle();
  }, []);

  const getCurrentEmailTemplateStyle = async () => {
    try {
      setIsLoading(true);
      const { id } = props.match.params;
      const { data } = await getEmailTemplateStyleById(id);
      if (data.success) delete data.success;
      setEmailTemplateStyle(data);
      setStyleSheet(data.styles);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      dispatch(showAlert('error', error.message));
    }
  };

  const handleUpdate = async e => {
    e.preventDefault();

    try {
      const updatedEmailTemplateStyle = { name: emailTemplateStyle.name, isEnabled: emailTemplateStyle.isEnabled, styles: styleSheet };

      await updateEmailTemplateStyle(emailTemplateStyle.id, updatedEmailTemplateStyle);

      dispatch(showAlert('success', 'Email template style has been updated! 🔥'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update the Email template style. 😔'));
      console.log(error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteEmailTemplateStyle(emailTemplateStyle.id);
      dispatch(showAlert('success', 'Email template style has been deleted! 🔥'));
      window.location.href = '/channels';
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not delete the Email template style. 😔'));
      console.log(error);
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>Email Template Style: {emailTemplateStyle?.name}</h1>
        <Button variant="contained" style={{ background: 'red', color: 'white' }} onClick={handleDelete}>
          Delete template
        </Button>
      </div>

      <section className="update-section">
        <form onSubmit={handleUpdate} className="update-form">
          <h3>Style properties:</h3>
          <div className="form-fields">
            <EditableInput data={styleSheet} setData={setStyleSheet} labels={Object.keys(styleSheet)} />
          </div>
          <Divider />
          <h3>Commom properties:</h3>
          <div className="form-fields">
            <EditableInput data={emailTemplateStyle} setData={setEmailTemplateStyle} labels={['name']} />
            <EditableSelect data={emailTemplateStyle} setData={setEmailTemplateStyle} labels={['isEnabled']} />
            <UneditableInput data={emailTemplateStyle} labels={['id', 'channelUid', 'createdAt', 'updatedAt', 'deletedAt']} />
          </div>
          <Button type="submit" className="update-btn" variant="contained" startIcon={<Save />}>
            Update email template style
          </Button>
        </form>
      </section>
    </>
  );
};

export default EmailTemplateStylesInformation;
